import { put } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import Logger from '../../../tools/Logger';

const log = Logger.child({
  component: 'mediator/openErrorToast',
});

export function* openErrorToast(action) {
  try {
    yield put(Actions.Modal.openModalCoachmark(action.params));
  } catch (err) {
    log.error(
      {
        obj: err,
      },
      'openModalCoachmark(): unable to openErrorToast',
    );
    return;
  }
}
